module.exports = __webpack_public_path__ + "static/media/arrow-right.fe85e827.svg";